const locationTypes = {
  OfficinaProveedor: 136,
  Hogar: 482,
  Escuela: 135,
  CSEE: 137,
  CAAT: 490,
  CiberterapiaAsistida: 491,
};

export default locationTypes;
